export const REQUIRED_ERR = "This field is required.";
export const TERMS_ERR = "You must agree with the terms and conditions.";
